import styled from "styled-components"

const StripeSpacer = styled.div`
  margin: 80px 0px;
  background: transparent;
  background-image: url(/stripe.png);
  background-size: cover;
  background-repeat: repeat;
  background-size: 86px;
  height: 64px;
  opacity: 0.3;
  box-shadow: inset 0px 0px 0px 1px;
  animation: 7s linear move infinite;

  @keyframes move {
    from {
      background-position-x: 0px;
    }
    to {
      background-position-x: 86px;
    }
  }
`

export default StripeSpacer
